import FilterField from "./components/Field";
import FiltersIcon from "@/assets/images/icons/filters.svg?inline";

export default {
  name: "filters-list",

  data() {
    return {
      isShowFilters: false
    };
  },

  props: {
    list: {
      type: Array,
      default: {}
    }
  },

  mounted: function() {},

  computed: {
    cacheFilters() {
      return JSON.parse(JSON.stringify(this.$store.getters.getFilters));
    }

    // filterAmounts() {
    //   if (
    //     this.$store.getters.getFilters &&
    //     this.$store.getters.getFilters.filters
    //   ) {
    //     let filters = this.$store.getters.getFilters.filters;

    //     let amount = filters.reduce((total, item) => {
    //       let values = JSON.parse(item.value);

    //       if (Array.isArray(values)) {
    //         for (let prop in values) {
    //           total.push(values[prop]);
    //         }
    //       } else {
    //         total.push(values);
    //       }
    //       return total;
    //     }, []);

    //     return amount.length;
    //   } else {
    //     return false;
    //   }
    // }
  },

  methods: {
    sendFilters() {
      this.$store.commit("setFilters", this.cacheFilters);
      this.isShowFilters = !this.isShowFilters;
    },

    updateSearchParams(data) {
      let filterIndex = this.cacheFilters.filters.findIndex(
        f => f.tagId == data.tagId
      );

      if (filterIndex >= 0) {
        this.$set(this.cacheFilters.filters, filterIndex, data);
      } else {
        this.cacheFilters.filters.push(data);
      }
    }
  },

  components: {
    FilterField,
    FiltersIcon
  }
};
